// Module
var code = "<div class=\"gc-overlay\" @click=\"stop({ event: $event })\"> <svg class=\"svg-overlay\"> <path d=\"{{path}}\"> <animate attributeName=\"d\" dur=\"200ms\"/> </path> </svg> </div>";
// Exports
export default code;